import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UserSaleGroup } from 'src/app/core/model/user/user-sale-group';

import { CustomListComponent } from '../custom-list/custom-list.component';

@UntilDestroy()
@Component({
  selector: 'app-custom-sales-claiming-list',
  templateUrl: './custom-sales-claiming-list.component.html',
  styleUrls: ['./custom-sales-claiming-list.component.scss'],
})
export class CustomSalesClaimingListComponent extends CustomListComponent {
  @Input() regionCode: string;
  @Input() currencySymbol: string;

  override itemsPerPageDisplayKey = `${this.translate.instant('Items per page')}:`;
  override entriesDisplayKey = '';

  private _allSelectable = false;
  @Input()
  get allSelectable(): boolean {
    return this._allSelectable;
  }

  set allSelectable(value: boolean) {
    this._allSelectable = value;
  }

  @Input()
  override get dataProvider(): any[] {
    return super.dataProvider;
  }

  override set dataProvider(value: any[]) {
    super.dataProvider = value;

    this.allSelectable = false;

    if (value) {
      value.forEach((item) => {
        this.allSelectable = this.allSelectable || this.itemSelectableFunction(item);
      });
    }
  }

  public calculateTotalSalesPoints(salesGroup: UserSaleGroup): number {
    return salesGroup.sales.reduce((sum, sale) => sum + sale.totalPoints, 0);
  }

  public calculateTotalServiceRevenue(salesGroup: UserSaleGroup): number {
    return salesGroup.sales.reduce(
      (sum, sale) => sum + (sale.isgServiceRevenue ?? 0) + (sale.idgServiceRevenue ?? 0),
      0
    );
  }

  public getANZRevenueLabel(salesGroup: UserSaleGroup): string {
    if (salesGroup && salesGroup.hasServiceRevenue) {
      if (salesGroup.sales.some((s) => (s.idgServiceRevenue ?? 0) > 0)) {
        return 'ANZ_IDG_revenue_label';
      }
      return 'ANZ_ISG_revenue_label';
    }

    return '';
  }

  public getANZPointsLabel(salesGroup: UserSaleGroup): string {
    if (salesGroup && salesGroup.hasServicePoints) {
      if (salesGroup.sales.some((s) => (s.idgServicePoints ?? 0) > 0)) {
        return 'ANZ_IDG_points_label';
      }
      return 'ANZ_ISG_points_label';
    }

    return '';
  }
}
